import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from 'actions';
import Login from 'cont/auth';
import NameWizard from 'comp/login/name_wizard';
import LoadScreen from 'comp/load_screen';
import FosolApp from 'comp/fosol';

class Fosol extends Component {
  constructor(props) {
    super(props);
    if (!this.props.is_loaded) {
      actions.loadInitialData();
    }
  }

  render() {
    const { show_login, user, is_loaded, ...props } = this.props;
    if (is_loaded) {
      if (!user.name || user.name === 'fosol_nameless') {
        return <NameWizard />;
      }
      return <FosolApp {...props} />;
    }
    if (show_login) {
      return <Login />;
    }
    return <LoadScreen />;
  }
}

const mapStateToProps = state => ({
  is_loaded: state.user && state.user.id && state.auth.list && state.auth.list.sessions,
  show_login: state.ui.show_login,
  user: state.user,
  selected_tab: state.ui.selected_app_tab,
  route_index: state.ui.route_index,
  jump_to_conv: state.ui.jump_to_conv
});

export default connect(mapStateToProps)(Fosol);



// WEBPACK FOOTER //
// ./src/containers/Fosol.js